import PropTypes from 'prop-types';
import Skeleton from 'wsm-skeleton';

import StarRating from './StarRating';

const RatingRow = ({ label, value, isSkeleton = false, textHeightSkeleton = '20px' }) => (
	<div className="d-table w-100 mb-3 ddc-font-size-medium">
		<div className="d-table-cell align-middle rating-label">
			<span>{label}</span>
		</div>
		<div className="d-table-cell align-middle">
			<div className="d-flex align-items-center ml-5">
				<StarRating 
					rating={isSkeleton ? 0 : parseFloat(value)} 
					ratingScale={5} 
					className={isSkeleton ? 'skeleton-loading' : ''}
				/>
				{isSkeleton ? (
					<Skeleton width="22px" height={textHeightSkeleton} skeletonClasses="ml-4 rounded" />
				) : (
					<span className="ml-4 font-weight-bold">{parseFloat(value).toFixed(1)}</span>
				)}
			</div>
		</div>
	</div>
);

RatingRow.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isSkeleton: PropTypes.bool,
	textHeightSkeleton: PropTypes.string
};

export default RatingRow;
